module.exports = __webpack_public_path__ + "images/graphic-letters_9be58df19781ae44ed187b36dc6870fe.png";